import React, { useEffect, useRef, useState } from "react";
import { Column } from "../../../../core/components/Column";
import { NavItem } from "../../../../core/components/NavItem";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { useLocation, useNavigate } from "react-router-dom";

export const Aside: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(window.innerWidth <= 768 ? true : false);
	const menuRef = useRef<HTMLDivElement>(null);
	const location = useLocation();
	const navigate= useNavigate();
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (window.innerWidth <= 768 && menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setIsMenuOpen(true);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMenuOpen]);

	useEffect(() => {
		if (window.innerWidth <= 768) {
			setIsMenuOpen(true);
		}
	}, [location.pathname]);

	return (
		<>
			<header className={`sticky top-0 bg-gradient-to-r from-cyan-600 to-blue-600 z-10 py-2 md:hidden shadow-white shadow-sm`}>
				<button
					onClick={() => setIsMenuOpen(!isMenuOpen)}
					type="button"
					className="p-2 rounded-md text-white hover:text-primary cursor-pointer "
					aria-controls="mobile-menu"
					aria-expanded={isMenuOpen}
				>
					<svg
						className="w-6 h-6"
						aria-hidden="true"
						fill="currentColor"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clipRule="evenodd"
							fillRule="evenodd"
							d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
						></path>
					</svg>
				</button>
			</header>
			{!isMenuOpen && <div className="fixed md:hidden z-20 h-screen w-full max-md:bg-[#00000060]" />}
			<Column
				ref={menuRef}
				crossAxisAlignment="center"
				className={`max-md:fixed top-0 left-0 z-20 min-w-fit max-md:h-full transition-transform  max-md:max-w-[3rem] 
					${isMenuOpen ? "-translate-x-full" : "translate-x-0"} bg-gradient-to-r from-cyan-600 to-blue-600 sticky top-0 gap-4 py-4 shadow-white shadow-sm`}
			>
				<Column
					crossAxisAlignment="center"
					className="gap-2 md:hidden  w-full"
				>
					<TextComponent
						variant="h1"
						className="uppercase font-bold text-white text-center py-4 md:py-16 flex-wrap px-8"
					>
						Opciones
					</TextComponent>
					<div className="h-[1px] w-full bg-white" />
				</Column>
				<Row
					className="md:gap-4 max-md:w-full"
					mainAxisAlignment="between"
					responsiveCol
				>
					<Row
						className="gap-1 max-md:hidden cursor-pointer select-none"
						crossAxisAlignment="center"
						mainAxisAlignment="center"
						onClick={() => {navigate("/")}}
					>
						<img
							className="w-8"
							src="/logo.png"
							alt="logo de la pagina"
						/>
						<TextComponent
							variant="h2"
							className="uppercase font-bold text-white"
						>
							CUIDEMOS EL MAÑANA
						</TextComponent>
					</Row>
					<NavItem
						title="Inicio"
						className="px-2"
						// icon={<HomeIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/"
						hiddenText={isMenuOpen}
						variant="header"
					/>
					<NavItem
						title="Plástica"
						className="px-2"
						// icon={<HeartIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/plastica"
						hiddenText={isMenuOpen}
						variant="header"
					/>
					<NavItem
						title="Minera"
						className="px-2"
						// icon={<BookMarkIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/minera"
						hiddenText={isMenuOpen}
						variant="header"
					/>
					<NavItem
						title="Pesca indiscriminada"
						className="px-2"
						// icon={<BookMarkIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/pesca"
						hiddenText={isMenuOpen}
						variant="header"
					/>
					<NavItem
						title="Agroquímica"
						className="px-2"
						// icon={<BookMarkIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/agroquimica"
						hiddenText={isMenuOpen}
						variant="header"
					/>
					<NavItem
						title="Soluciones"
						className="px-2"
						// icon={<BookMarkIcon className="min-w-5 max-w-5 aspect-square" />}
						href="/soluciones"
						hiddenText={isMenuOpen}
						variant="header"
					/>
				</Row>
			</Column>
		</>
	);
};
